var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'badge badge-' + _vm.variant,style:('font-size: ' + _vm.size + 'em')},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" "),(_vm.withX)?_c('small',[_c('i',{staticClass:"fas fa-times"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }